





































import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import AddressList from '@/components/Address/List.vue';
import AddressForm from '@/components/Address/Form.vue';
import user from '@/store/modules/user';
import store from '@/store';
import checkout from '@/store/modules/checkout';
import cart from '@/store/modules/cart';
import { QuoteAddress } from '@/store/models';
import { Validator } from 'vee-validate';
import { getSimilarMethod, encode as encodeShipment } from '@/commons/shipmentMethodHelpers';
import addressNormalizer, { copyAddressData } from '@/commons/addressNormalizer';

@Component({
  components: {
    AddressList,
    AddressForm,
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
})
export default class CourierMethod extends Vue {
  @Inject() public $validator!: Validator;

  private mounted() {
    if (this.sameasbilling && !this.isLogged) {
      checkout.copyBillingAddressToShippingAddress();
    }
  }

  @Watch('sameasbilling')
  private onSameAsBillingChange(val: any, oldVal: any) {
    if (val && !this.isLogged) {
      checkout.copyBillingAddressToShippingAddress();
      this.confirmAddress(this.address);
    }
  }

  get sameasbilling(): boolean {
    return checkout.shippingSameAsBillingFlag;
  }

  set sameasbilling(val: boolean) {
    checkout.setShippingSameAsBillingFlag(val);
  }

  get isLogged(): boolean {
    return user.isLoggedin;
  }

  get hasAddresses(): boolean {
    return user.customer.addresses.length > 0;
  }

  get showEditAddress(): boolean {
    return checkout.editShippingAddress;
  }

  get editAddress(): any {
    return user.editAddress;
  }

  get address(): any {
    return addressNormalizer(checkout.shippingAddress);
  }

  private async confirmAddress(address: any){
    const valid = await this.$validator.validateAll();
    if (valid) {
      if (address.firstname) {
        copyAddressData(address, checkout.shippingAddress);
      }
      this.$emit('courierAddressConfirmed', checkout.shippingAddress);
    }
  }

  private async addressSelectedHandler(address: any) {
    const isMulticarrier = store.state.options.carrier.multicarrier;
    if (isMulticarrier) {
      cart.flagLoading({key: 'shipMethods', value: true});
      const currentlySelected = checkout.selectedShippingMethod;
      await checkout.estimateShippingSimple(this.address);
      const similarMethod = getSimilarMethod(currentlySelected, checkout.shippingMethods);

      if (similarMethod) {
        checkout.setSelectedShipment(encodeShipment(similarMethod));
      } else {
        checkout.setSelectedShipment('');
      }
      cart.flagLoading({key: 'shipMethods', value: false});
    }

  }
}
